/*
 * @Description: 国安西班牙语
 * @Author: zml
 * @Date: 2023-03-23 14:52:59
 * @LastEditors: zml
 * @LastEditTime: 2023-09-22 12:16:02
 */
export default {
    "LLH.login":"Iniciar sesión",
    "LLH.register":"Registro",
    "LLH.logout":"Salida",
    "LLH.MyOrder":"Mi pedido",
    "LLH.logoBox.placeholder": "Por favor, introduzca la palabra clave del producto",
    "LLH.logoBox.search": "Buscar",
    "LLH.logoBox.AdvancedSearch": "Búsqueda avanzada",
    "LLH.nav.Home": "página de inicio",
    "LLH.nav.Products": "Productos",
    "LLH.nav.About": "Sobre nosotros",
    "LLH.nav.contact": "Contáctanos",
    "LLH.nav.news": "Noticias",
    "LLH.nav.cart": "Carrito de compras",
    "LLH.ViewPrice": "Ver el precio",
    "LLH.SameFactory": "La misma fábrica",
    "LLH.newPro": "Nuevos productos",
    "LLH.AnotherBatch": "Cambiar un lote",
    "LLH.ViewMore": "Ver más",
    "LLH.hotPro": "Productos de venta caliente",
    "LLH.hotVidio": "Video caliente",
    "LLH.proUnBoxVidio": "Video de apertura del producto",
    "LLH.Search": "Buscar",
    "LLH.Reset": "Restablecer",
    "LLH.ItemNO": "Número del proyecto",
    "LLH.MTCode": "Número de la empresa",
    "LLH.FTYCode": "Número de fábrica",
    "LLH.Kind": "Tipo",
    "LLH.Size": "Especificaciones",
    "LLH.Price": "Precio",
    "LLH.Date": "Fecha",
    "LLH.Sort": "Ordenar",
    "LLH.DateDesc": "Fecha Bajar",
    "LLH.DateAsc": "Fecha Subir",
    "LLH.PriceDesc": "Precio Bajar",
    "LLH.PriceAsc": "Precio Subir",
    "LLH.NO.Desc": "Número Bajar",
    "LLH.NO.Asc": "Número Subir",
    "LLH.PleaseEnterTheProductNameKeyword": "Introduzca la palabra clave del nombre del producto",
    "LLH.PleaseSelect": "Por favor, elija",
    "LLH.PleaseLength": "Largo",
    "LLH.PleaseWidth": "Ancho",
    "LLH.PleaseHeight": "Alto",
    "LLH.PleaseMinPrice": "Precio mínimo",
    "LLH.PleaseMaxPrice": "Precio máximo",
    "LLH.PleaseStartDate": "Fecha de inicio",
    "LLH.PleaseEndDate": "Fecha de finalización",
    "LLH.UserAccount": "Cuenta",
    "LLH.password": "Contraseña",
    "LLH.GROUPSEARCH": "Búsqueda integral",
    "LLH.Video_playback": "Reproducción de vídeo",
    "LLH.loginMsg": "Acceso a su cuenta y historial de pedidos",
    "LLH.onUserAccount": "No hay cuenta",
    "LLH.SignUp": "Registro",
    "LLH.ForgetPassword": "Olvida la contraseña",
    "LLH.resetPasswords": "Restablecer la contraseña",
    "LLH.emailAddress": "Buzón",
    "LLH.verifyCode": "Código",
    "LLH.getVerifyCode": "Acceso Código",
    "LLH.newPassword": "Nueva contraseña",
    "LLH.confirmPassword": "Confirmar contraseña",
    "LLH.Submit": "Presentación",
    "LLH.SignUpAccount": "Cuenta registrada",
    "LLH.LoginOnly": "Solo para iniciar sesión",
    "LLH.Name": "Nombre",
    "LLH.NameMsg": "Introduzca su nombre, de 2 a 30 caracteres",
    "LLH.passwordMsg": "Al menos 6 caracteres",
    "LLH.requiredFields": "*obligatorio",
    "LLH.Email": "Buzón",
    "LLH.EmailMsg": "Por favor, introduzca el buzón. Para iniciar sesión.",
    "LLH.gender": "Género",
    "LLH.man": "Hombre",
    "LLH.woman": "Señora",
    "LLH.customerSource": "Fuente del cliente",
    "LLH.salesman": "Vendedor",
    "LLH.Country": "País",
    "LLH.companyName": "Empresa",
    "LLH.duty": "Cargo",
    "LLH.tel": "Teléfono",
    "LLH.mobile": "Teléfono móvil",
    "LLH.fax": "Fax",
    "LLH.Yahoo": "Yahoo",
    "LLH.website": "Sitio web",
    "LLH.address": "Dirección",
    "LLH.postalCode": "Código postal",
    "LLH.ExistingAccount": "Cuenta existente",
    "LLH.DirectLogin": "Iniciar sesión directamente",
    "LLH.productPrice": "Precio del producto",
    "LLH.ProductNumber": "Número de producto",
    "LLH.Packing": "Método de embalaje",
    "LLH.OuterBoxCBM": "Volumen de la caja exterior",
    "LLH.OuterBoxCUFT": "Volumen de la caja exterior",
    "LLH.Innerboxes": "Número de cajas interiores",
    "LLH.OuterQTY": "Volumen de la caja exterior",
    "LLH.GWAndNW": "Peso bruto / neto",
    "LLH.productSize": "Especificaciones del producto",
    "LLH.packageSize": "Especificaciones de embalaje",
    "LLH.cartonSize": "Especificaciones de la caja exterior",
    "LLH.addCart": "Añadir carrito de compras",
    "LLH.delCart": "Fuera del carrito de la compra",
    "LLH.product": "Productos",
    "LLH.NewsUpdates": "Novedades periodísticas",
    "LLH.ReleaseDate":"Fecha de publicación",
    "LLH.MyCart":"Mi carrito de compras",
    "LLH.ID":"ID",
    "LLH.picture":"Imagen",
    "LLH.ArticleNo": "Número",
    "LLH.Description": "Nombre del producto",
    "LLH.CartOuterQTY":"Fuera",
    "LLH.CBM":"CBM",
    "LLH.CTNS":"CTNS",
    "LLH.totalQTY": "Total",
    "LLH.TotalVolume":"Total CBM",
    "LLH.total":"Total",
    "LLH.delete":"Eliminar",
    "LLH.checkAll":"Selección completa",
    "LLH.clear":"Vaciado",
    "LLH.totalItems": "Número total",
    "LLH.totalCTNS": "Volumen total de cajas",
    "LLH.noData": "No hay datos por el momento",
    "LLH.totalPrice": "Precio total",
    "LLH.systemTip": "Consejos del sistema",
    "LLH.confirm": "Determinar",
    "LLH.cancel": "Cancelación",
    "LLH.deleteData": "¿¿ quieres eliminar este dato?",
    "LLH.clearCartData": "¿¿ vaciar todos los carritos de la compra?",
    "LLH.submitTip": "¿Confirmar la presentación del pedido?",
    "LLH.MyOrder": "Mi pedido",
    "LLH.PleaseOrderNum": "Por favor, introduzca el número de pedido.",
    "LLH.number": "Número único",
    "LLH.viewDetails": "Ver detalles",
    "LLH.orderTime": "Tiempo de creación",
    "LLH.linkman": "Contactos",
    "LLH.sendDate": "Tiempo de envío",
    "LLH.expressNumber": "Número de la lista de mensajería",
    "LLH.orderStatus": "Estado del pedido",
    "LLH.unshipped": "No enviado",
    "LLH.shipped": "Enviado",
    "LLH.SiteNavigation": "Navegación del sitio web",
    "LLH.ContactUs": "Contáctanos",
    "LLH.FollowUs": "Preste atención a nosotros",
    "LLH.Landline": "Avión fijo",
    "LLH.Email": "Buzón",
    "LLH.Phone": "Móvil",
    "LLH.WeChat": "WeChat",
    "LLH.Technic": "Soporte técnico",
    "LLH.Software": "HongSheng Soft",
    "LLH.detailBtn": "Detalles del producto",
    "LLH.noDetailBtn": "No Detalles del producto",
    "LLH.classify": "Clasificación",
    "LLH.exclusive": "Recomendaciones exclusivas para",
    "LLH.loading": "Cargado...",
    "LLH.updateTime": "Tiempo",
    "LLH.SearchMsg": "Los criterios de búsqueda anteriores son opcionales para cualquiera o más búsquedas integrales.",
    "LLH.MessageTitle": "Enviar sus necesidades en línea",
    "LLH.MessageMsg": "Responderemos a su correo electrónico en 24 horas, excepto en días festivos.",
    "LLH.MessageName": "Tu nombre",
    "LLH.MessageTel": "Tu teléfono móvil",
    "LLH.MessageEmail": "Tu buzón",
    "LLH.MessageNeeds": "Tus necesidades",
    "LLH.SendInquiry": "Investigación",
    "LLH.EnquiryList": "Investigación",
    "LLH.enquiry": "Investigación",
    "LLH.MyEnquiryList": "Mi formulario de consulta",
    "LLH.Remark": "Nota",
    "LLH.Enquirys": "Deje su correo electrónico para facilitar el contacto.",
    "LLH.proClass": "Clasificación de productos",
    "LLH.submitOrder": "¿Confirmar la presentación de la consulta?",
}   
